import Konva from "konva";

const SIZE_MAP = [13, 17, 32];

export class CNText {
    constructor(tool) {
        this.tool = tool;
        this.data = tool;
        this.id = tool.d[0];
        this.x = tool.d[1];
        this.y = tool.d[2];
        this.text = tool.d[3];
        this.color = tool.d[4] || "#000000";
        this.size = tool.d[5];
        this.name = tool.t;
        this.version = tool.v;
        this.removerImage = tool.removerImage;

        this.remover = this.buildRemover();

        this.element = this.buildElement();
        this.element.setAttrs({
            instance: this,
        });
    }

    pasteData(inc) {
        const data = this.data.d;
        return [
            "tx" + +new Date(),
            data[1] + 30 * inc,
            data[2] + 30 * inc,
            data[3],
            data[4],
            data[5],
        ];
    }

    setClickAction(callback) {
        this.element.on("click", callback);
        this.element.on("tap", callback);
    }

    setDblClickAction(callback) {
        this.element.on("dblclick", callback);
        this.element.on("dbltap", callback);
    }

    setClickOutsideAction(callback) {
        this.clickOutsideAction = callback;
    }

    setUpdateAction(callback) {
        this.updateAction = callback;
    }

    edit() {
        const _this = this;
        _this.textNode.hide();
        _this.anchor.hide();

        const textPosition = _this.textNode.absolutePosition();
        const stage = _this.textNode.getStage();
        const stageBox = stage.container().getBoundingClientRect();

        const areaPosition = {
            x: stageBox.left + textPosition.x,
            y: stageBox.top + textPosition.y,
        };

        const textarea = document.createElement("textarea");
        document.body.appendChild(textarea);

        textarea.value = _this.textNode.text();
        textarea.style.position = "absolute";
        textarea.style.top = areaPosition.y + "px";
        textarea.style.left = areaPosition.x + "px";
        textarea.style.width =
            _this.textNode.width() - _this.textNode.padding() * 2 + "px";
        textarea.style.height =
            _this.textNode.height() - _this.textNode.padding() * 2 + 5 + "px";
        textarea.style.fontSize =
            _this.textNode.fontSize() * stage.scale().x + "px";
        textarea.style.border = "none";
        textarea.style.padding = "0px";
        textarea.style.margin = "0px";
        textarea.style.overflow = "hidden";
        textarea.style.background = "none";
        textarea.style.outline = "none";
        textarea.style.resize = "none";
        textarea.style.lineHeight = _this.textNode.lineHeight();
        textarea.style.fontFamily = _this.textNode.fontFamily();
        textarea.style.transformOrigin = "left top";
        textarea.style.textAlign = _this.textNode.align();
        textarea.style.color = _this.textNode.fill();

        const rotation = _this.textNode.rotation();
        let transform = "";
        if (rotation) {
            transform += "rotateZ(" + rotation + "deg)";
        }
        transform += "translateY(-" + 2 + "px)";
        textarea.style.transform = transform;

        textarea.style.height = "auto";
        textarea.style.height = textarea.scrollHeight + 3 + "px";

        textarea.focus();

        function removeTextarea() {
            textarea.parentNode.removeChild(textarea);
            window.removeEventListener("click", handleOutsideClick);
            _this.textNode.show();
        }

        function setTextareaWidth(newWidth) {
            if (!newWidth) {
                newWidth =
                    _this.textNode.placeholder.length *
                    _this.textNode.fontSize();
            }
            textarea.style.width = newWidth + "px";
        }

        textarea.addEventListener("keydown", function (e) {
            if (e.keyCode === 13 && !e.shiftKey) {
                _this.textNode.text(textarea.value);
                _this.updateAction(textarea.value);
                removeTextarea();
            }
            if (e.keyCode === 27) {
                removeTextarea();
            }
        });

        textarea.addEventListener("keydown", function () {
            const scale = _this.textNode.getAbsoluteScale().x;
            setTextareaWidth(_this.textNode.width() * scale);
            textarea.style.height = "auto";
            textarea.style.height =
                textarea.scrollHeight + _this.textNode.fontSize() + "px";
        });

        function handleOutsideClick(e) {
            if (e.target !== textarea) {
                _this.textNode.text(textarea.value);
                _this.anchor.hide();
                _this.anchor.forceUpdate();
                _this.clickOutsideAction();

                _this.updateAction(textarea.value);
                removeTextarea();
            }
        }
        setTimeout(() => {
            window.addEventListener("click", handleOutsideClick);
        });
    }

    setDragStart(callback) {
        this.element.on("dragstart", (e) => callback(e));
    }

    setColor(color) {
        this.textNode.fill(color);
    }

    setDragEnd(callback) {
        this.element.on("dragend", (e) => callback(e));
    }

    buildRemover() {
        const remover = new Konva.Image({
            image: this.removerImage,
            width: 20,
            height: 20,
            name: "remover",
            x: -20,
            y: -20,
            visible: false,
        });
        remover.on("mouseover", () => {
            document.body.style.cursor = "pointer";
        });
        remover.on("mouseout", () => {
            document.body.style.cursor = "default";
        });

        return remover;
    }

    setRemoverAction(callback) {
        this.remover.on("click", () => {
            callback();
        });
        this.remover.on("tap", () => {
            callback();
        });
    }

    updateText(text) {
        this.textNode.text(text);
        this.text = text;
    }

    buildElement() {
        const group = new Konva.Group({
            id: this.id,
            name: this.name,
            x: this.x,
            y: this.y,
            draggable: true,
        });

        console.log("size", this.size);
        this.textNode = new Konva.Text({
            text: this.text,
            fontSize: SIZE_MAP[this.size],
            width: 200,
            name: "text",
            fill: this.color,
        });

        this.anchor = new Konva.Transformer({
            name: "anchor",
            node: this.textNode,
            rotateEnabled: false,
            enabledAnchors: [
                "middle-left",
                "middle-right",
                "top-center",
                "bottom-center",
            ],
            boundBoxFunc: function (oldBox, newBox) {
                newBox.width = Math.max(30, newBox.width);
                return newBox;
            },
        });

        const _this = this;
        this.textNode.on("transform", function () {
            _this.textNode.setAttrs({
                width: _this.textNode.width() * _this.textNode.scaleX(),
                scaleX: 1,
            });
        });
        group.add(this.textNode);
        group.add(this.remover);
        // group.add(this.anchor);

        return group;
    }
}
